module.exports = __webpack_public_path__ + "media/PlantAnalytics_IN.04459b71.mp4";